import { exclusionContract } from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { type z } from "zod";

export const COPY_EXCLUSIONS_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/exclusion/copy`;

export type CopyExclusionsRequest = z.input<typeof exclusionContract.copyExclusions.body>;
export type CopyExclusionsResponse = z.output<
  (typeof exclusionContract.copyExclusions.responses)[201]
>;

export type UseCopyExclusionsOptions = Omit<
  UseMutationOptions<CopyExclusionsResponse, AxiosError, CopyExclusionsRequest>,
  "mutationFn"
>;

export type UseCopyExclusionsResult = UseMutationResult<
  CopyExclusionsResponse,
  AxiosError,
  CopyExclusionsRequest
>;

export function useCopyExclusions(options: UseCopyExclusionsOptions = {}): UseCopyExclusionsResult {
  return useMutation({
    ...options,
    mutationFn: async (variables) => {
      const response = await post({
        url: COPY_EXCLUSIONS_URL,
        data: variables,
        bodySchema: exclusionContract.copyExclusions.body,
        responseSchema: exclusionContract.copyExclusions.responses[201],
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.COPY_EXCLUSIONS_FAILURE,
    },
  });
}
